<form novalidate #setupForm="ngForm">
  <div class="setup-container">
    <div class="section-container">
      <div class="section-label identity">Identity</div>
      <div class="section-data">
        <nrwl-test-identity
          [testName]="testName"
          [customer]="customerName"
          [technician]="technicianName"
          [contact]="contact"
          [email]="email"
          [phone]="phone"
          [technicianId]="technicianId"
          [comments]="comments"
          [editMode]="editMode || cloneMode"
          (updateTestIdentity)="updateTestIdentity($event)"
        ></nrwl-test-identity>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Endpoints</div>
      <div class="endpoints-container">
        <div class="endpoint-section">
          <nrwl-agent-picker
            [testType]="'ftp'"
            [originatorDevice]="selectedOriginator"
            [destinationDevice]="selectedDestination"
            [editMode]="editMode"
            [testMode]="testMode"
            [direction]="direction"
            [showDirections]="showDirections"
            [showDirectionIcons]="true"
            (emitAgents)="onAgentChange($event)"
          ></nrwl-agent-picker>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Test Setup</div>
      <div class="section-data">
        <div class="group">
          <div class="label">Type</div>
          <mat-select
            class="option-list"
            name="testType"
            [(ngModel)]="formField.testType"
            #testTypeInput="ngModel"
            (ngModelChange)="onTestTypeChange()"
          >
            <mat-option *ngFor="let opt of testTypes" [value]="opt.value">{{
              opt.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">TCP Port</div>
          <mat-select
            class="option-list"
            #tcpPortInput="ngModel"
            [(ngModel)]="formField.tcpPort"
            name="tcpPort"
            (ngModelChange)="onTcpPortChange()"
            required
          >
            <mat-option *ngFor="let tcp of tcpPortData" [value]="tcp.value">{{
              tcp.name
            }}</mat-option>
          </mat-select>
          <mat-error class="error" *ngIf="isTCPPortError && !isValidYangModel(isTCPPortError)">{{
            isTCPPortError
          }}</mat-error>
        </div>
        <div class="group">
          <div class="slide-btn">
            <mat-slide-toggle
              #thresholdToggleElement
              name="threshold"
              [checked]="formField.threshold"
              class="enable-row"
              color="primary"
              (change)="thresholdToggleChange(thresholdToggleElement)"
            >
            </mat-slide-toggle>
            <div class="label label-valign">Throughput Threshold (L1)</div>
          </div>
          <div class="threshold-container" *ngIf="formField.threshold">
            <div class="upload-sec" *ngIf="direction !== testModeOptions.DOWNLOAD">
              <div class="label">Upload *</div>
              <input
                matInput
                autocomplete="off"
                type="number"
                class="input-data width-65"
                name="uploadeThreshold"
                [(ngModel)]="formField.uploadThreshold"
                (input)="enforceMaxLength($event, 5)"
                (keypress)="handleDecimal($event)"
                (paste)="handleDecimalPaste($event)"
                #uploadeThresholdInput="ngModel"
                (ngModelChange)="onUploadThresholdChange()"
                required
              />
              <span class="unit-label">Mbps</span>
              <div
                class="error"
                *ngIf="
                  (uploadeThresholdInput.invalid &&
                    (uploadeThresholdInput.dirty || uploadeThresholdInput.touched)) ||
                  !isValidThreshold(formField.uploadThreshold)
                "
              >
                <mat-error *ngIf="uploadeThresholdInput?.errors?.required"> Required</mat-error>
                <mat-error
                  *ngIf="
                    maxBandWidth &&
                    !isValidThreshold(formField.uploadThreshold) &&
                    !uploadeThresholdInput?.errors?.required
                  "
                  >Threshold range is {{ thresholdMinValue }} - {{ maxBandWidth }}
                </mat-error>
              </div>
              <div
                class="error"
                *ngIf="
                  !isUploadThresholdValid &&
                  maxBandWidth &&
                  isValidThreshold(formField.uploadThreshold)
                "
              >
                Threshold is more than the target
              </div>
            </div>
            <div class="download-sec" *ngIf="direction !== testModeOptions.UPLOAD">
              <div class="label">Download *</div>
              <input
                matInput
                autocomplete="off"
                type="number"
                class="input-data width-65"
                name="downloadeThreshold"
                [(ngModel)]="formField.downloadThreshold"
                (input)="enforceMaxLength($event, 5)"
                (keypress)="handleDecimal($event)"
                (paste)="handleDecimalPaste($event)"
                #downloadeThresholdInput="ngModel"
                (ngModelChange)="onDownloadThresholdChange()"
                required
              />
              <span class="unit-label">Mbps</span>
              <div
                class="error"
                *ngIf="
                  (downloadeThresholdInput.invalid &&
                    (downloadeThresholdInput.dirty || downloadeThresholdInput.touched)) ||
                  !isValidThreshold(formField.downloadThreshold)
                "
              >
                <mat-error *ngIf="downloadeThresholdInput?.errors?.required"> Required</mat-error>
                <mat-error
                  *ngIf="
                    maxBandWidth &&
                    !isValidThreshold(formField.downloadThreshold) &&
                    !downloadeThresholdInput?.errors?.required
                  "
                  >Threshold range is {{ thresholdMinValue }} - {{ maxBandWidth }}
                </mat-error>
              </div>
              <div
                class="error"
                *ngIf="
                  !isDownloadThresholdValid &&
                  maxBandWidth &&
                  isValidThreshold(formField.downloadThreshold)
                "
              >
                Threshold is more than the target
              </div>
            </div>
          </div>
        </div>
        <div class="group">
          <div class="slide-btn">
            <mat-slide-toggle
              #targetThroughputToggleElement
              name="target"
              [checked]="formField.target"
              class="enable-row"
              color="primary"
              (change)="targetThroughputToggleChange(targetThroughputToggleElement)"
            >
            </mat-slide-toggle>
            <div class="label label-valign">Target Throughput (L1)</div>
          </div>
          <div class="threshold-container" *ngIf="formField.target">
            <div class="upload-sec" *ngIf="direction !== testModeOptions.DOWNLOAD">
              <div class="label">Upload *</div>
              <input
                matInput
                autocomplete="off"
                type="number"
                class="input-data width-65"
                name="uploadTarget"
                [(ngModel)]="formField.uploadTarget"
                (input)="enforceMaxLength($event, 5)"
                (keypress)="handleDecimal($event)"
                (paste)="handleDecimalPaste($event)"
                #uploadTargetInput="ngModel"
                (ngModelChange)="onUploadTargetThroughputChange()"
                required
              />
              <span class="unit-label">Mbps</span>
              <div
                class="error"
                *ngIf="
                  (uploadTargetInput.invalid &&
                    (uploadTargetInput.dirty || uploadTargetInput.touched)) ||
                  !isValidTargetThroughput(formField.uploadTarget)
                "
              >
                <mat-error *ngIf="uploadTargetInput?.errors?.required"> Required</mat-error>
                <mat-error
                  *ngIf="
                    maxBandWidth &&
                    !isValidTargetThroughput(formField.uploadTarget) &&
                    !uploadTargetInput?.errors?.required
                  "
                  >Throughput range is {{ minBandWidth }} - {{ maxBandWidth }}
                </mat-error>
              </div>
              <div
                class="error"
                *ngIf="
                  !isUploadTargetValid &&
                  maxBandWidth &&
                  isValidTargetThroughput(formField.uploadTarget)
                "
              >
                Target is less than the threshold
              </div>
            </div>
            <div class="download-sec" *ngIf="direction !== testModeOptions.UPLOAD">
              <div class="label">Download *</div>
              <input
                matInput
                autocomplete="off"
                type="number"
                class="input-data width-65"
                name="downloadeTarget"
                (input)="enforceMaxLength($event, 5)"
                (keypress)="handleDecimal($event)"
                (paste)="handleDecimalPaste($event)"
                [(ngModel)]="formField.downloadTarget"
                #downloadTargetInput="ngModel"
                (ngModelChange)="onDownloadTargetThroughputChange()"
                required
              />
              <span class="unit-label">Mbps</span>
              <div
                class="error"
                *ngIf="
                  (downloadTargetInput.invalid &&
                    (downloadTargetInput.dirty || downloadTargetInput.touched)) ||
                  !isValidTargetThroughput(formField.downloadTarget)
                "
              >
                <mat-error *ngIf="downloadTargetInput?.errors?.required"> Required</mat-error>
                <mat-error
                  *ngIf="
                    maxBandWidth &&
                    !isValidTargetThroughput(formField.downloadTarget) &&
                    !downloadTargetInput?.errors?.required
                  "
                  >Throughput range is {{ minBandWidth }} - {{ maxBandWidth }}
                </mat-error>
              </div>
              <div
                class="error"
                *ngIf="
                  !isDownloadTargetValid &&
                  maxBandWidth &&
                  isValidTargetThroughput(formField.downloadTarget)
                "
              >
                Target is less than the threshold
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isDisabledScheduler" class="section-container height-120">
      <div class="section-label"><label>Schedule</label></div>
      <div class="scheduler-section">
        <viavi-scheduler
          [scheduleValue]="scheduleInfoData"
          (schedulerDataVal)="fetchSchedulerVal($event)"
          [isDisabledScheduler]="isDisabledScheduler"
          [schedulerEnds]="schedulerEnds"
        >
        </viavi-scheduler>
      </div>
    </div>
  </div>
</form>
